import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import DataFlowV2Service from "src/modules/data-protection/apis/DataFlowV2Service";
import { isEndpointCounterpartType } from "../helpers/flowForm";

export const DATA_FLOW_ENDPOINTS_QUERY_KEY = "data-flow-endpoints";

const useDataFlowEndpoints = ({ type, q = "", enabled = false, t } = {}) => {
    return useQuery({
        queryKey: [DATA_FLOW_ENDPOINTS_QUERY_KEY, type, q],
        queryFn: async () => {
            const service = DataFlowV2Service.getInstance();
            const response = await service.listEndpoints({
                q,
                type,
                limit: 25,
                offset: 0,
            });

            return response?.data?.endpoints || [];
        },
        enabled: Boolean(enabled && isEndpointCounterpartType(type)),
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            toast(t("An error occurred while fetching counterparts."), {
                type: "error",
            });
        },
    });
};

export default useDataFlowEndpoints;
